export default "__VITE_ASSET__Bydyft4N__"